/*       */

import { gql } from '@apollo/client';

export default gql`
    mutation userUpdatePosition($latitude: String!, $longitude: String!) {
        userUpdatePosition(latitude: $latitude, longitude: $longitude)
    }
`;
